import { openBlock as l, createElementBlock as r, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(i, t) {
  return l(), r("svg", n, [...t[0] || (t[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
